import React from 'react'
import ReactDOM from 'react-dom'
import { Turnstile } from '@marsidev/react-turnstile'
import axios from 'axios'

const csrfToken = document.querySelector('meta[name=csrf-token]').content

axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

function renderCaptcha () {
  ReactDOM.render(
    <Turnstile
      siteKey={window.TURNSTILE_SITE_KEY}
      onSuccess={(token) => {
        document.getElementById('game_log_analyze_form_turnstile_token').value = token
      }} />,
    document.getElementById('turnstile-ctn'),
  )
}

renderCaptcha()

if (window.jobID) {
  function redirect () {
    window.location.href = `/game_log_analyzers/${window.jobID}/results`
  }

  function checkIfResultsAreReady () {
    axios.get(`/game_log_analyzers/${window.jobID}/check_results`)
      .then(function (response) {
        if (!response.data.status || ['failed', 'completed'].includes(response.data.status)) {
          redirect()
        } else {
          setTimeout(checkIfResultsAreReady, 1000)
        }
      })
      .catch(function (error) {
        redirect()
      })

  }

  checkIfResultsAreReady()
}
